const faqsAnalyticsClick = ({ faq }) => {
  const { question = '' } = faq;
  if (!faq.isOpenedOnce) {
    // eslint-disable-next-line no-param-reassign
    faq.isOpenedOnce = true;
    if (window && window.metrics) {
      window.metrics.link(`FAQ-opened_${question}`);
    }
  }
};

let locationNames = [];

/* Getting linkName for metrics.click */
const findLinkName = (el) => el.dataset && el.dataset.analyticsId;
/* Getting Location Name for metrics.click */
const findLocationName = (el) => el.dataset && el.dataset.locationName;
/* Getting Location Name for metrics.click */
const locationNameEl = (el) => el.closest('[data-location-name]');

/* recursively check for parent location names and create string */
const getLocationNames = (el) => {
  const parentEl = locationNameEl(el.parentNode);
  if (parentEl) {
    locationNames.unshift(findLocationName(parentEl));
    getLocationNames(parentEl);
  }
  return locationNames.join('_');
};

/* Getting alt text from child image */
const getAltText = (el) => {
  const image = el.querySelector('img');
  if (image) return image.getAttribute('alt');
  return false;
};

/* Create linkName from text or alt */
const createLinkName = (el) => {
  const rawText = `${el.dataset.analyticsId || el.textContent || getAltText(el)}`.trim() || 'undefined';
  return rawText;
};
/* Finding reportable parent element or none */
const findClickElement = (target) => {
  const linkOrButton = target.closest('a, button');
  if (linkOrButton) return linkOrButton;
  return false;
};

/* Tracking clicks */
const trackClicks = (metrics, event) => {
  locationNames = [];
  const { target } = event;
  // find which element to pull the linkData From
  const clickEl = findClickElement(target);
  if (clickEl) {
    // find the linkName to pass
    const linkName = findLinkName(clickEl)
      || createLinkName(clickEl);

    // check for location names
    const locationNameString = getLocationNames(target);
    const linkNameValue = locationNameString ? `${locationNameString}_${linkName}` : linkName;

    if (linkNameValue) {
      const linkData = { linkName: linkNameValue };
      metrics.link(linkData, event);
    }
  }
};

/* Initialize analytics */
const initAnalytics = (config) => {
  const {
    metrics,
    wrapSelector,
  } = config;

  // get dynamic components
  const dynamicElms = document.querySelectorAll(`${wrapSelector} [data-analytics-config="dynamic"]`);

  // get all anchor and button elements within the static components
  const staticElms = Array.from(document.querySelectorAll(`${wrapSelector} > *:not([data-analytics-config="dynamic"]) a, ${wrapSelector} > *:not([data-analytics-config="dynamic"]) button`));
  // To exclude analytics call, add one of the suitable config mentioned below!

  const excludeElms = Array.from(document.querySelectorAll(`
    ${wrapSelector} [data-analytics-config="exclude"] > a, 
    ${wrapSelector} [data-analytics-config="exclude"] > button,
    ${wrapSelector} [data-analytics-config="exclude"] #faq > button,
    ${wrapSelector} [data-analytics-config="exclude-all"] a, 
    ${wrapSelector} [data-analytics-config="exclude-all"] button`));

  // filter out excluded elements
  const filteredElms = staticElms.filter((e) => !excludeElms.includes(e));

  // gather elements to attach listeners to
  const listenerArray = [Array.from(dynamicElms), filteredElms];

  listenerArray.forEach((arr) => {
    if (arr) {
      [].forEach.call(arr, (element) => {
        element.addEventListener('click', trackClicks.bind(null, metrics));
      });
    }
  });
};

export {
  initAnalytics,
  faqsAnalyticsClick,
};
